// extracted by mini-css-extract-plugin
export var footer = "_lo-0";
export var inherit = "_lo-1";
export var input = "_lo-2";
export var modalContent = "_lo-3";
export var quillEditor = "_lo-4";
export var subtitle = "_lo-5";